import { AppSettings } from "../app.settings";
import { DateUtility } from "./date.utility";
import { Md5 } from 'ts-md5/dist/md5';
import { AgentUtility } from "./agent.utility";
import { environment } from "environments/environment";

export class StringUtility {
    public static PhoneMask(str) {
        if (str == null)
            return "";
        if (str == 'none') {
            return str;
        }
        if (str.length < 10)
            return "+7 (000) " + str;
        let viewStr = '';
        let listStr = str ? str.split(',') : '';
        if (listStr != '') {
            listStr.forEach(phone => {
                phone = phone.trim();
                if (phone.length < 10) {
                    phone = "000" + phone;
                }
                if (viewStr != '') viewStr += ', ';
                viewStr += '<span>+7&nbsp;(' + phone[0] + phone[1] + phone[2] + ')&nbsp;' + phone[3] + phone[4] + phone[5]
                    + '&nbsp;' + phone[6] + phone[7]
                    + '&nbsp;' + phone[8] + phone[9] + '</span>';
            });
        }
        return viewStr;
    }

    public static getNewPaymentURL(IDS:number, fee:number
        ,  insureName:string, insureSurname:string,  insureMiddlename:string
        , currency:string):string{
            environment
        let URL:string = environment.payUrl+"?"+
        "disable_regular_payment=1"+
        "&policy_number="+IDS+
        "&fee="+fee+
        "&insured_i="+ insureSurname+
        "&insured_f="+ insureName+
        "&insured_o="+  insureMiddlename+
        "&currency="+currency+
        "&payer_i="+insureSurname+
        "&payer_f="+insureName+
        "&payer_o="+insureMiddlename+
        "&is_payer=1";
        return URL;
    }

    public static getGamificationScript = (name: string, container: string, type: string, width?: number, height?: number, limit?: number) => {
        const domain = 'https://game.renlife.com';
        const key = "ZiXqYtt5yFUi21Wvv5vi5hLxcz9q8xzktVcrIeqk89uza8u513lX5Grt1g2jyMWb";
        const user = AgentUtility.getUser().Id;

        if (!user) {
            return false;
        }

        const sign = Md5.hashStr(user + key);
        const auth = "user=" + user + "&sign=" + sign;

        let params = "" +
            (width ? "&width=" + width : "") +
            (height ? "&height=" + height : "") +
            (limit ? "&limit=" + limit : "");

        const s = document.createElement("script");
        s.type = "text/javascript";

        switch (type) {
            case 'info':
                s.src = domain + '/api/widgets/' + name + '?' + auth + '&container=' + container + params;
                break;
            case 'module':
                s.src = domain + '/api/widgets/iframe?' + auth + '&name=' + name + '&container=' + container + params;
                break;
            default:
                return false;
        }

        return s;
    }
}